import React, { PropsWithChildren } from 'react';
import { AppBar } from '../AppBar';
import { Box } from '../Box';
import { Overlay } from '../Overlay';
import { Pane } from '../Pane';
import css from './index.module.scss';

interface FullScreenExperienceProps {
  onCloseSignal: () => void;
  open: boolean;
  left?: React.ReactNode;
  right?: React.ReactNode;
  middle?: React.ReactNode;
  height?: number;
  maxWidth?: number;
  testId?: string;
}

export const FullScreenExperience: React.FC<PropsWithChildren<FullScreenExperienceProps>> = ({
  children,
  open,
  onCloseSignal,
  left,
  right,
  middle,
  maxWidth,
  testId,
  height,
}) => (
  <Overlay data-component="FullScreenExperience" open={open} onClose={onCloseSignal}>
    <div className={css.container} data-testid={testId}>
      <Box className={css.content} maxWidth={maxWidth} collapsible>
        <Pane borderBottom="standard">
          <AppBar height={height} left={left} right={right} middle={middle} />
        </Pane>
        {children}
      </Box>
    </div>
  </Overlay>
);
